import { School } from '@teetsh/app/src/types/school';
import { useEffect, useState } from 'react';
import useUpdateSchool from '@teetsh/app/src/queries/schools/useUpdateSchool';
import useDebounce from '@teetsh/app/src/utils/useDebounce';

export default function useUpdateSchoolDebounce(
  sch: School,
  schoolyearId: string,
): [School, (v: School) => void] {
  const [school, setSchool] = useState<School>(sch);
  const updateSchool = useUpdateSchool(schoolyearId);
  const debouncedSave = useDebounce(nextValue => updateSchool(nextValue), 500);
  useEffect(() => {
    setSchool(sch);
  }, [sch.uai, JSON.stringify(sch)]);

  const handleChange = (v: School) => {
    setSchool(v);
    debouncedSave(v);
  };
  return [school, handleChange];
}
